module.exports = __webpack_public_path__ + "img/search-cards.2453d5b0.svg";